var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3125 25.35C20.0875 26.5375 18.75 26.35 17.4625 25.7875C16.1 25.2125 14.85 25.1875 13.4125 25.7875C11.6125 26.5625 10.6625 26.3375 9.58749 25.35C3.48749 19.0625 4.38749 9.4875 11.3125 9.1375C13 9.225 14.175 10.0625 15.1625 10.1375C16.6375 9.8375 18.05 8.975 19.625 9.0875C21.5125 9.2375 22.9375 9.9875 23.875 11.3375C19.975 13.675 20.9 18.8125 24.475 20.25C23.7625 22.125 22.8375 23.9875 21.3 25.3625L21.3125 25.35ZM15.0375 9.0625C14.85 6.275 17.1125 3.975 19.7125 3.75C20.075 6.975 16.7875 9.375 15.0375 9.0625Z",
    fill: "#64737E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.b47c66386997f3316489ec1fdc7d1556.svg";
export { ForwardRef as ReactComponent };